import { useReduxState } from 'hooks';
import { getFormattedDate } from 'lib/common';
import { ContentBox, TimeIndicator, Tooltip } from 'components/common';

import type { Discussion } from './DiscussionContainer';

interface Props {
  discussion: Discussion;
}

const DiscussionSummary = ({ discussion }: Props) => {
  const { language, messages, theme } = useReduxState();

  const { data, lastReply, numberOfComments, numberOfOwnComments } = discussion;

  return (
    <ContentBox title={data.title || messages.readerDiscussion}>
      <div className="content">
        <div
          className="question"
          dangerouslySetInnerHTML={{ __html: data.text }}
        />

        <div className="replies">
          <strong>{numberOfComments}</strong>
          {` ${messages.tasksDiscussionsReplies}, `}
          <strong>{numberOfOwnComments}</strong>
          {` ${messages.tasksDiscussionsRepliesFromYou}`}
        </div>

        {lastReply ? (
          <div className="replies date">
            <div className="date-value">
              {`${messages.tasksDiscussionsLastReply} `}
              <Tooltip
                childrenWrapInDiv={false}
                content={getFormattedDate({
                  date: lastReply,
                  dateFormat: 'dd.MM.y HH:mm'
                })}
              >
                <span className="date-value-time">
                  <TimeIndicator language={language} timeString={lastReply} />
                </span>
              </Tooltip>
            </div>
          </div>
        ) : null}
      </div>

      <style jsx>{`
        .content {
          display: flex;
          flex-direction: column;
        }
        .question {
          color: ${theme.textColorLight};
          font-size: 1.6rem;
        }
        .question :global(p) {
          margin: 8px 0 0;
        }
        .question :global(p:first-child) {
          margin-top: 0;
        }
        .replies {
          color: ${theme.textColorLighter};
          font-size: 1.5rem;
          font-weight: 600;
          margin-top: 20px;
          margin-left: auto;
          margin-right: 0;
        }
        .replies strong {
          color: ${theme.textColorLight};
        }
        .date {
          font-size: 1.4rem;
          margin-top: 5px;
        }
        .date-value-time {
          text-transform: lowercase;
        }
      `}</style>
    </ContentBox>
  );
};

export default DiscussionSummary;
